import _ from 'lodash';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
//import moment from 'moment';

//- Material UI / Style
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { getGlobalClasses } from '../../themes';

//containers
import AuthUserContainer from '../../containers/AuthUser';
import TicketContainer from '../../containers/Ticket/Ticket';
import TicketCategoryContainer from '../../containers/Ticket/TicketCategory';

//- UI / Form
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';

//import SectionHeader from "../../components/SectionHeader";
//import CompanyDepartmentPicker from "../../components/advancedForm/CompanyDepartmentPicker";
import TicketCategoryPicker from '../../components/advancedForm/TicketCategoryPicker';
import FormDatePicker from '../../components/form/FormDatePicker';
import SectionHeader from '../../components/SectionHeader';
import UserPicker from '../../components/advancedForm/UserPicker';
import Note from '../../components/Note';
import FleetDepartmentPicker from '../../components/advancedForm/FleetDepartmentPicker';
import DownloadIcon from '@material-ui/icons/CloudDownload';
import SearchIcon from '@material-ui/icons/Search';
import CircularProgress from '@material-ui/core/CircularProgress';
import TicketTable from '../../components/table/TicketTable';

const isLocalhost = Boolean(window.location.hostname === 'localhost');

const styles = (theme) => {
	return {
		...getGlobalClasses(theme),
		submitButton: {
			marginTop: 20,
			fontSize: 16,
			borderRadius: '100px',
			padding: '13px 45px',
			textTransform: 'uppercase',
			marginRight: 10,
		},
		icon: {
			paddingRight: 5,
		},
		resultsHere: {
			padding: 30,
			backgroundColor: '#f1f1f1',
			color: '#777',
			borderRadius: 10,
		},
		runningSearch: {
			paddingLeft: 20,
			display: 'flex',
			alignItems: 'center',
			fontSize: 18,
			color: '#666',
		},
	};
};

class Save extends Component {
	constructor(props) {
		super(props);
		this.state = {
			formFieldError: {},

			afterDate: moment().subtract(15, 'days').format('YYYY-MM-DD'),
			beforeDate: moment().format('YYYY-MM-DD'),
			searchResultRows: undefined,
			order: 'desc',
			orderBy: 'stationInvoiceId',
			isSearching: false,
		};
	}

	componentDidUpdate(prevProps, prevState, snapShot) {}

	//- Path is always a string
	//- value is never an event (value.target)
	onChange = (value, path, error) => {
		const arrayPath = _.toPath(path);
		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			if (arrayPath.length > 1) {
				base = _.cloneDeep(base);
				_.set(base, arrayPath.slice(1), value);
				newState[basePath] = base;
			} else {
				newState[basePath] = value;
			}
		} else {
			newState[basePath] = value;
		}

		//- Clear any errors on the path
		let formFieldError = Object.assign({}, this.state.formFieldError);

		if (error) {
			formFieldError[path] = error;
		} else {
			delete formFieldError[path];
		}
		newState.formFieldError = formFieldError;

		this.setState(newState);
	};

	getApiParams = () => {
		const { accessToken } = this.props;
		const { afterDate, beforeDate } = this.state;

		const afterMoment = moment(afterDate);
		const beforeMoment = moment(beforeDate);

		const params = {
			accessToken,
			afterDate: afterMoment.format('YYYY-MM-DD'),
			beforeDate: beforeMoment.format('YYYY-MM-DD'),
		};

		[
			'userIdOnRecord',
			'assignedToUserId',
			'openedByUserId',
			'fleetDepartment',
			'ticketCategoryId',
			'parentTicketCategoryId',
		].forEach((s) => {
			if (this.state[s]) {
				params[`${s}s`] = [this.state[s]];
			}
		});

		const { userIdOnRecord } = this.state;
		if (userIdOnRecord) {
			params.userIdsOnRecord = [userIdOnRecord];
		}
		return params;
	};

	handleSearch = () => {
		const { advancedTicketSearch, showErrors } = this.props;

		const formFieldError = {};
		const requiredFields = [
			{ path: 'afterDate', label: 'After Date' },
			{ path: 'beforeDate', label: 'Before Date' },
		];

		requiredFields.forEach(({ path, label }) => {
			if (!this.state[path]) {
				formFieldError[path] = `${label} is required`;
			}
		});

		const { afterDate, beforeDate } = this.state;

		const afterMoment = moment(afterDate);
		const beforeMoment = moment(beforeDate);

		if (afterMoment.isAfter(beforeMoment)) {
			formFieldError.afterDate = `Before date can't be before after date. Time is not a circle man.`;
		}

		//- Get all the values and do individual checks
		if (_.keys(formFieldError).length) {
			this.setState({ formFieldError });
			showErrors(_.values(formFieldError));
			return;
		}

		const params = this.getApiParams();

		this.setState({
			isSearching: true,
		});

		setTimeout(() => {
			advancedTicketSearch({
				params,
				callback: (err, r) => {
					this.setState({ isSearching: false });
					if (err) {
						return showErrors(_.isArray(err) ? err : [err]);
					}

					const searchResultRows = _.get(r, 'collections.ticketCollection', []);
					this.setState({
						savingStatus: 'done',
						searchResultRows,
						searchResultBulkRows: undefined,
					});
				},
			});
		}, 250);
	};

	getInputProps = (path, defaultValue) => {
		return {
			key: path,
			path,
			value: this.getValue(path, defaultValue),
			checked: this.getValue(path, defaultValue),
			error: this.getError(path),
			onChange: this.onChange,
			gridProps: { md: 12 },
		};
	};

	getValue = (path, defaultValue) => {
		const _d = _.isUndefined(defaultValue) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};

	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	render() {
		const { classes } = this.props;

		const { isSearching, searchResultRows } = this.state;

		if (this.props.authUser?.role === 'driver') {
			return <div>You are not authorized to view this page.</div>;
		}
		const params = this.getApiParams();

		params.downloadCsv = true;
		const request = {
			method: 'ticket.advancedSearch',
			params,
		};
		const domain = isLocalhost ? 'http://localhost:3702' : '';
		const downloadUrl = `${domain}/api?request=${JSON.stringify(request)}`;
		//const downloadUrl = `/api?request=${JSON.stringify(request)}`;

		return (
			<form>
				<Paper className={classes.globalMainPaper} style={{ minHeight: 500 }}>
					<div className={classes.globalMainHeadline}>Advanced Ticket Search</div>

					<Grid spacing={2} container>
						<Grid item xs={12} sm={11} md={10} lg={8}>
							<Grid spacing={2} container>
								<Grid item xs={12}>
									<Note type={'info'}>
										Leave any fields blank that you don't want to factor into the search.
									</Note>
								</Grid>

								<SectionHeader label={'Date Range'} gridProps={{ md: 12 }} />

								<FormDatePicker
									{...this.getInputProps('afterDate')}
									label="Created after date"
									format={'MMMM Do, YYYY'}
								/>

								<FormDatePicker
									{...this.getInputProps('beforeDate')}
									label="Created before date"
									format={'MMMM Do, YYYY'}
								/>

								<SectionHeader label={'Employees'} gridProps={{ md: 12 }} />

								<UserPicker
									{...this.getInputProps('userIdOnRecord')}
									label="Employee on record"
									helpText={
										`eg : The driver who had the incident, employee who was late, ` +
										`dispatcher who messed up, etc`
									}
								/>

								<UserPicker
									{...this.getInputProps('assignedToUserId')}
									label="User assigned to the ticket"
									whoToShow={'nonDriversOnly'}
								/>

								<UserPicker
									{...this.getInputProps('openedByUserId')}
									label="User who opened the ticket"
									whoToShow={'nonDriversOnly'}
								/>

								<SectionHeader label={'Category / Fleet / Dept'} gridProps={{ md: 12 }} />

								<TicketCategoryPicker
									{...this.getInputProps('parentTicketCategoryId')}
									label="Parent Ticket Category"
									onlyShowParents={true}
								/>

								<TicketCategoryPicker
									{...this.getInputProps('ticketCategoryId')}
									label="Individual Ticket Category"
								/>

								<FleetDepartmentPicker
									{...this.getInputProps('fleetDepartment')}
									label="Fleet / Department"
								/>

								<Grid item xs={12} style={{ padding: '20px 0px' }}>
									<Button
										onClick={this.handleSearch}
										variant="contained"
										color="primary"
										className={classes.submitButton}
									>
										<SearchIcon className={classes.icon} />
										Search
									</Button>

									<a
										href={downloadUrl}
										style={{ textDecoration: 'none', paddingRight: 5 }}
										target="_blank"
										rel="noreferrer noopener"
									>
										<Button variant="contained" color="primary" className={classes.submitButton}>
											<DownloadIcon className={classes.icon} />
											Search & Download
										</Button>
									</a>

									{isSearching && (
										<div className={classes.runningSearch}>
											<CircularProgress />
											<span style={{ paddingLeft: 10 }}>Searching...</span>
										</div>
									)}
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Paper>

				<Paper className={classes.globalMainPaper}>
					{_.isUndefined(searchResultRows) && (
						<div className={classes.resultsHere}>Results here</div>
					)}
					{!_.isUndefined(searchResultRows) && this.renderResults()}
				</Paper>
			</form>
		);
	}

	renderResults = () => {
		const { userMap, ticketSchemaMap, ticketCategoryMap, history } = this.props;

		const { searchResultRows } = this.state;

		return (
			<TicketTable
				tickets={searchResultRows}
				filter={''}
				ticketSchemaMap={ticketSchemaMap}
				ticketCategoryMap={ticketCategoryMap}
				userMap={userMap}
				history={history}
			/>
		);
	};
}

Save.propTypes = {
	advancedTicketSearch: PropTypes.func.isRequired,

	userMap: PropTypes.object,
	ticketSchemaMap: PropTypes.object,
	ticketCategoryMap: PropTypes.object,

	showErrors: PropTypes.func.isRequired,
	authUser: PropTypes.object,
	classes: PropTypes.object.isRequired,
};

export default _.flow([
	withStyles(styles),
	AuthUserContainer,
	TicketContainer,
	TicketCategoryContainer,
])(Save);
